<template>
  <v-app-bar app
             :class="useClass"
  >
    <v-toolbar-title
      class="headline font-weight-medium grey--text text--darken-1"
      @click="navigateTo('home')"
      style="cursor:pointer">
      <v-icon large class="mr-2">
        mdi-access-point
      </v-icon>
      <span>Livepaow</span>
    </v-toolbar-title>

    <v-spacer />
    <v-layout
      align-center
      justify-end
      row
      fill-height
      class="pr-5 hidden-xs-only"
    >
      <paow-language-selector />
    </v-layout>
    <paow-manage-store-button
      :user="user"
      class="mr-1"
    />
    <paow-sign-in-button
      :user="user"
    />
    <paow-user-avatar />
  </v-app-bar>
</template>

<script>
import PaowLanguageSelector from '../../components/PaowLanguageSelector'
import PaowManageStoreButton from '../../components/PaowManageStoreButton'
import PaowSignInButton from '../../components/PaowSignInButton'
import PaowUserAvatar from '../../components/PaowUserAvatar'
import helpers from '../../mixins/helpers'
import { mapState } from 'vuex'

export default {
  name: 'TheBar',
  mixins: [helpers],
  props: {
    useClass: {
      type: String,
      default: null
    }
  },
  components: {
    PaowLanguageSelector,
    PaowSignInButton,
    PaowManageStoreButton,
    PaowUserAvatar
  },
  computed: {
    ...mapState({
      user: state => state.user.status
    })
  }
}
</script>

<style>

</style>
